import { OAuthFetcher, Fetcher } from './../../utils/fetch';
import Config from './../../config';

export function GetUser() {
    return OAuthFetcher.makeRequest('/info', `GET`);
}

export function getUserTokens(key = '') {
    return Fetcher.makeRequest('/users/auth/tokens', 'POST', { key });
}

export function validateToken() {
    return Fetcher.makeRequest(`/users/auth/verify`, `GET`);
}

export function refreshToken() {
    return Fetcher.makeRequest(`/users/auth/refresh`, `PUT`, null, {}, true);
}

export function loadUserInfo(id = '') {
    return Fetcher.makeRequest(`/users/${id}`, `GET`);
}


export function loadUsers(page = 1, filter = {}) {
    return Fetcher.makeRequest(`/users?page=${page}&domain=${Config.OAUTH_DOMAIN}`, `GET`);
}

export function updateUsers(user_id = '', data = {}) {
    return Fetcher.makeRequest(`/users/${user_id}`, `PUT`, data);
}




// WEBPACK FOOTER //
// ./src/containers/user/api.js